import AttorneyShell from "@/components/AttorneyShell";
import CriPanel from "@/components/CriPanel";
import CfiPanel from "@/components/CfiPanel";
import RetainerPanel from "@/components/RetainerPanel";
import DispatchPanel from "@/components/DispatchPanel";
import ServiceRequestsPanel from "@/components/ServiceRequestsPanel";
import DemandBuilder from "@/components/DemandBuilder";
import { EvidenceIntelPanel } from "@/components/EvidenceIntelligence";
import EvidenceAIStudio from "@/components/EvidenceAIStudio";
import VoiceTimeline from "@/components/VoiceTimeline";

export default function CaseIntelligence() {
  return (
    <AttorneyShell>
      <CriPanel />
      <CfiPanel />
      <RetainerPanel />
      <DispatchPanel />
      <ServiceRequestsPanel />
      <EvidenceIntelPanel />
      <EvidenceAIStudio />
      <DemandBuilder />
      <VoiceTimeline />
    </AttorneyShell>
  );
}
